import type { UpcomingItem } from './types.js';

/** Where an upcoming item is managed. */
export function upcomingHref(u: UpcomingItem): string {
  switch (u.type) {
    case 'obligation':
      return '/obligations';
    case 'document':
      return '/documents';
    case 'service':
      return '/services';
    case 'warranty':
      return '/belongings';
    case 'birthday':
      return `/people?birthdayMonth=${Number(u.dueOn.slice(5, 7))}`;
    case 'task':
      return '/tasks?view=upcoming';
    case 'event':
      return '/plan';
  }
}
